module.exports = __webpack_public_path__ + "img/pdf.d2c09133.png";